// components/group/FeedTab.jsx
import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

import { groupFeedApi } from './feed/feedApi';
import FeedList from './feed/FeedList';

export default function FeedTab({ groupId }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const data = await groupFeedApi.listFeed(groupId, { limit: 50 });
      setItems(data || []);
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.detail ||
          t('feed.toastLoadError', { defaultValue: 'Failed to load feed' })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!groupId) return;
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  return (
    <Card className="overflow-hidden">
      <CardHeader>
        <CardTitle>{t('feed.title', { defaultValue: 'Group feed' })}</CardTitle>
        <CardDescription>
          {t('feed.description', {
            defaultValue: 'Posts, courses, and other content shared in this group.',
          })}
        </CardDescription>
      </CardHeader>

      <CardContent className="space-y-4">
        {loading ? (
          <p className="text-slate-500 text-sm">
            {t('feed.loading', { defaultValue: 'Loading…' })}
          </p>
        ) : items.length === 0 ? (
          <p className="text-slate-500 text-sm">
            {t('feed.noItems', { defaultValue: 'No content yet.' })}
          </p>
        ) : (
          <FeedList groupId={groupId} items={items} />
        )}
      </CardContent>
    </Card>
  );
}
